import {createEffect, createEvent, createStore, forward} from "effector";
import {AuthApi} from "@/apis";

const getDefaultAuthStore = () => {
    const token = localStorage.getItem("token", null);
    return {
        token: token,
        isAuthenticated: !!token,
    };
};

export const $auth = createStore(getDefaultAuthStore(), {
    name: "auth",
});
export const auth = createEvent("auth");
export const getTokenFx = createEffect("getToken");

getTokenFx.use(AuthApi.getToken);

forward({
    from: auth,
    to: getTokenFx,
});

$auth.on(getTokenFx.doneData, (_, token) => {
    if (!token) {
        alert("Ошибка входа");
        return {
            token: null,
            isAuthenticated: false,
        };
    }
    localStorage.setItem("token", token);
    return {
        token,
        isAuthenticated: true,
    };
});


const getDefaultTerminalIdStore = () => {
    const terminalId = localStorage.getItem("terminalId", null);
    return terminalId;
};

export const $terminalId = createStore(getDefaultTerminalIdStore(), {
    name: "terminalId",
});
export const saveTerminalId = createEvent("saveTerminalId");
export const getTerminalIdFx = createEffect("getTerminalId");

forward({
    from: saveTerminalId,
    to: getTerminalIdFx,
});

$terminalId.on(getTerminalIdFx, (_, terminalId) => {
    if (!terminalId) {
        return;
    }
    localStorage.setItem("terminalId", terminalId);
    return terminalId;
});


const getDefaultOrientationStore = () => {
    const orientation = localStorage.getItem("orientation", null);
    return orientation;
};

export const $orientation = createStore(getDefaultOrientationStore(), {
    name: "orientation",
});
export const saveOrientation = createEvent("saveOrientation");
export const getOrientationFx = createEffect("getOrientation");

forward({
    from: saveOrientation,
    to: getOrientationFx,
});

$orientation.on(getOrientationFx, (_, orientation) => {
    if (!orientation) {
        return;
    }
    localStorage.setItem("orientation", orientation);
    return orientation;
});
